import React from 'react'

const PolitykaPrywatnosci = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial, sans-serif', lineHeight: 1.6 }}>
      <h1>Polityka prywatności – MTT Ubezpieczenia</h1>
      <p><strong>Obowiązuje od: 09.06.2025</strong></p>

      <h2>1. Administrator danych</h2>
      <p>
        Administratorem danych osobowych jest:<br />
        <strong>Małgorzata Tyc-Tomiczek</strong><br />
        MTT Ubezpieczenia<br />
        ul. Plażowa 3, 34-360 Milówka<br />
        NIP: 5532219670<br />
        REGON: 522573772<br />
        E-mail: <a href="mailto:mtt.ubezpieczenia@gmail.com">mtt.ubezpieczenia@gmail.com</a><br />
        Telefon: <a href="tel:+48666691526">+48 666 691 526</a>
      </p>

      <h2>2. Zakres zbieranych danych</h2>
      <p>
        Strona internetowa <strong>ubezpieczeniamilowka.pl</strong> ma charakter informacyjny (wizytówka) i nie zbiera danych osobowych za pomocą formularzy.
        Dane mogą być przekazane dobrowolnie poprzez kliknięcie linku e-mail lub numeru telefonu.
      </p>

      <h2>3. Pliki cookies</h2>
      <p>
        Strona może wykorzystywać pliki <strong>cookies</strong> w celu:
        <ul>
          <li>wyświetlania treści (np. mapy Google, czcionki),</li>
          <li>analizowania ruchu (np. Google Analytics – jeśli zostanie wdrożony w przyszłości).</li>
        </ul>
        Użytkownik może wyłączyć obsługę cookies w swojej przeglądarce.
      </p>

      <h2>4. Cele przetwarzania danych</h2>
      <p>Dane mogą być przetwarzane w celu prowadzenia korespondencji lub realizacji uzasadnionych interesów Administratora.</p>

      <h2>5. Prawa użytkownika</h2>
      <p>
        Użytkownik ma prawo do:
        <ul>
          <li>dostępu do swoich danych,</li>
          <li>poprawienia, usunięcia lub ograniczenia przetwarzania,</li>
          <li>wniesienia sprzeciwu,</li>
          <li>złożenia skargi do Prezesa UODO.</li>
        </ul>
      </p>

      <h2>6. Przechowywanie danych</h2>
      <p>Dane są przechowywane wyłącznie tak długo, jak jest to konieczne do realizacji celu kontaktowego lub zgodnie z prawem.</p>

      <h2>7. Udostępnianie danych</h2>
      <p>Dane nie są udostępniane podmiotom trzecim bez zgody użytkownika, chyba że wymagają tego przepisy prawa.</p>

      <h2>8. Zmiany polityki</h2>
      <p>
        Administrator zastrzega sobie prawo do zmian niniejszej polityki prywatności. Aktualna wersja jest zawsze dostępna na stronie.
      </p>
    </div>
  )
}

export default PolitykaPrywatnosci